import { Pagination } from "antd";
import { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { crmFilteredData } from "../../shared/crm-filter";
import { AdvancedSearchFilterBar } from "../AdvancedSearchFilterBar/AdvancedSearchFilterBar";
import { AdvancedSearchItem } from "../AdvancedSearchItem/AdvancedSearchItem";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import Button from "../Button/Button";
import { SellChartModal } from "../Dialog/SellChartModal";
import Loading from "../Loadings/LoadingTable";
import Typography from "../Typography/Typography";
import { AdvancedSearchWrapper } from "./AdvancedSearchStyle";
import { pageNumber } from "../../shared/crmAdvancedSearchPageNumber";
import { useEffect } from "react";
export const AdvancedSearch = () => {
  const FilteredData = useRecoilValue(crmFilteredData);
  const [NumberPage, setNumberPage] = useRecoilState(pageNumber);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const pageCount = FilteredData?.pages[0]?.data?.Numbersales_opportunities;
  useEffect(() => {
    setLoading(false);
  }, [FilteredData]);

  return (
    <AdvancedSearchWrapper>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="جستجوی پیشرفته"
        href1="/dashboard/crm"
      />
      <div className="row filter-page ">
        <div className="mb-4 col-lg-3 col-md-12 col-12">
          <div className="filters">
            <div className="flex items-center justify-between filters-header">
              <Typography size="14px">فیلتر</Typography>
              <Button
                small="fit-content"
                className="text-[14px] m-0"
                onclick={() => setShow(true)}
              >
                نمودار خرید
              </Button>
            </div>
            <div className="filters-content">
              <AdvancedSearchFilterBar />
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-12 col-12 ">
          <div className="filters-result">
            <div className="filters-header">
              <Typography size="14px">
                کل اشخاص{" "}
                {FilteredData?.pages[0]?.data?.Numbersales_opportunities}
              </Typography>
            </div>

            <div className="results">
              <div className="row">
                {loading ? (
                  <Loading />
                ) : (
                  <>
                    {FilteredData ? (
                      <AdvancedSearchItem data={FilteredData} advanced={true} />
                    ) : (
                      <Loading />
                    )}
                  </>
                )}
                <div className="text-center">
                  <Pagination
                    defaultCurrent={1}
                    total={pageCount}
                    pageSize={28}
                    onChange={(e) => {
                      setNumberPage(e);
                      setLoading(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SellChartModal show={show} handleClose={() => setShow(false)} />
    </AdvancedSearchWrapper>
  );
};
